import styled from 'styled-components';

export const TopMargin = styled.div`
  margin-top: 100px;
`;
